import { FaEnvelope } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './AccountCreated.module.css'; // adjust path if needed
import Button from '../../components/Button/Button';
import buttonStyles from '../../components/Button/Button.module.css';

const AccountCreated = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <FaEnvelope size={80} color="#2e7d32" />
      </div>
      <h1 className={styles.title}>Verify it's you!</h1>
      <p className={styles.message}>
        Please verify your email by clicking the link sent to <strong>{email}</strong>
      </p>
      <p className={styles.hint}>
        Don’t see it? Check your spam folder for an email from <strong>no-reply@377storage.vip</strong>
      </p>
    <Button className={buttonStyles.inverted1} onClick={handleLoginRedirect}>Go to Login</Button>
    </div>
  );
};

export default AccountCreated;
